import { useCallback, useState } from 'react';

import type { marketingFaq } from '../../../../app/_shared/marketing/landingContent';
import { withEmphasis } from './emphasisText';
import './landingRef.css';

type Item = (typeof marketingFaq)[number];

type Props = {
  h2: string;
  intro?: string;
  items: readonly Item[];
};

export function FaqSection({ h2, intro, items }: Props) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = useCallback((index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  }, []);

  return (
    <section className="faq-section" aria-labelledby="faq-heading">
      <header className="faq-section__header">
        <h2 id="faq-heading" className="ml-heading-serif ml-text-heading">
          {h2}
        </h2>
        {intro ? <p className="faq-section__intro ml-text-body-secondary">{intro}</p> : null}
      </header>
      <div className="faq-section__list">
        {items.map((item, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          const buttonId = `faq-button-${index}`;
          return (
            <div key={item.q} className={'faq-item' + (isOpen ? ' faq-item--open' : '')}>
              <h3 className="faq-item__heading">
                <button
                  type="button"
                  id={buttonId}
                  className="faq-item__question"
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                  onClick={() => toggle(index)}>
                  <span>{item.q}</span>
                  <span className="faq-item__icon" aria-hidden />
                </button>
              </h3>
              <div
                id={panelId}
                role="region"
                aria-labelledby={buttonId}
                aria-hidden={!isOpen}
                className={'faq-item__answer' + (isOpen ? ' faq-item__answer--open' : '')}>
                <p>{withEmphasis(item.a)}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
